<template>
    <v-tooltip bottom >
      <v-btn
        v-if="!edit"
        slot="activator"
        text-color="white"
        class="d-inline-block bg_white"
        @click.native="handleOpenDialogInsert"
        id="btn_consultaAvulsa"
      >
        <v-icon color="teal" small>mdi-plus</v-icon>
        <small>Nova Nota</small>
      </v-btn>
      <v-btn v-else-if="edit && nota.origem != 'MotorV2' && nota.statusEmissao === 'falha'" slot="activator" dark icon small flat @click.native="handleOpenDialog">
        <v-icon style="margin-top: 1px; margin-right: 1px;" class="material-icons">edit</v-icon>
        <!-- <v-icon style="color:red; margin-top: 1px; margin-right: 1px;">mdi-alert-decagram</v-icon> -->
      </v-btn>
      
      <span v-if="!edit">Incluir nova nota</span>
      <span v-else>Editar nota</span>
    
    <v-dialog
          @keydown.esc="handleCancelar"
          persistent
          v-model="dialog"
          max-width="760px"
        >
          
          <v-card>
            <v-toolbar dark class="headline darkBlue">
              <v-toolbar-title v-if="!edit">Incluir Nova Nota</v-toolbar-title>
              <v-toolbar-title v-else>Editar Nota</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon dark @click.native="handleCancelar">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <article>
              <div v-if="failureMessages">
              <v-alert
                :value="true"
                type="error"
                :dismissible="true"
                style="padding:5px;"
              >
              {{failureMessages}}
                
              </v-alert>
              </div>

            <v-card-text style="width: 90%;margin: auto;" class="form_empresa_inputs">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                <v-layout row wrap>

                  <v-flex xs12 sm6>


                    <v-menu
                      :close-on-content-click="false"
                      v-model="showDate"
                      :nudge-right="40"
                      color="teal"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        :close-on-content-click="true"
                        color="teal"
                        slot="activator"
                        v-model="date2"
                        persistent-hint
                        clearable
                        class="input-required"
                        :rules="date2 ? dateRules : razaoRules"
                        @blur="validateDate()"
                        :mask="mask.date"
                        validate-on-blur
                        required
                        ref="dataInput"
                      >
                        <template slot="label">Data da prestação do serviço</template>
                      </v-text-field>
                      <v-date-picker
                        @input="date2 = formatDate($event), showDate = false"
                        @change="eventDate($event)"
                        locale="pt-br"
                        v-model="date"
                        :max="nowDate"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>

                </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                          v-model="cnpj"
                          required
                          flat
                          :mask="mask.cnpj"
                          @keydown.delete="mask ? mask.cnpj = '' : ''"
                          @keyup="trocaCampoCpfCnpj($event, cnpj)"
                          :rules="cnpj && cnpj.length > 11 ? cnpjRules : cpfRules"
                          label="CPF/CNPJ"
                          clearable
                          validate-on-blur
                          class="input-required"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                          v-model="razao"
                          label="Razão Social / Nome do Tomador"
                          class="input-required"
                          required
                          clearable
                          validate-on-blur
                          :rules="razaoRules"
              
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="email"
                            label="E-mail"
                            class="input-required"
                            required
                            clearable
                            validate-on-blur
                            :rules="email ? emailRules : razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="cep"
                            label="CEP"
                            class="input-required"
                            required
                            :mask="mask.cep"
                            @keydown.delete="mask ? mask.cep = '' : ''"
                            @keyup="trocaCampoCep($event, cep)"
                            @keypress="isNumber($event)"
                            clearable
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-autocomplete
                          v-model="estado"
                          :autocomplete="false"
                          validate-on-blur
                          item-text="sigla"
                          class="input-required"
                          :items="arrayEstados"
                          label="Estado"
                          clearable
                          persistent-hint
                          no-data-text="Consulta de Estado indisponível"
                          return-object
                          @change="getMunicipios"
                          :rules="razaoRules"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-autocomplete
                            label="Município"
                            :autocomplete="false"
                            validate-on-blur
                            item-text="nome"
                            :items="arrayMunicipios"
                            v-model="municipio"
                            clearable
                            class="input-required"
                            persistent-hint
                            no-data-text="Selecione um Estado"
                            return-object
                            :rules="razaoRules"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="bairro"
                            label="Bairro"
                            class="input-required"
                            required
                            clearable
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="logradouro"
                            label="Logradouro"
                            class="input-required"
                            required
                            clearable
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="numero"
                            label="Número"
                            class="input-required"
                            required
                            type="number"
                            clearable
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="complemento"
                            label="Complemento"
                            clearable
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="inscricaoMunicipal"
                            label="Inscrição municipal do tomador"
                            @keypress="isNumber($event)"
                            clearable
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="telefone"
                            label="Telefone"
                            clearable
                            validate-on-blur
                            :mask="'(##)#########'"
                            @keypress="isNumber($event)"
                            :rules="telefone ? telefoneRules : []"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="valor"
                            label="Valor"
                            class="input-required"
                            required
                            clearable
                            validate-on-blur
                            @input="maskValor(valor)"
                            @keypress="isNumber($event)"
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12>
                        <v-textarea
                            v-model="discriminacao"
                            label="Discriminação do(s) serviço(s) prestados"
                            class="input-required"
                            required
                            clearable
                            auto-grow
                            row-height="4"
                            style="font-size: 0.8em;"
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-textarea>
                    </v-flex>

                     <v-flex xs12 sm4>
                        <v-text-field
                            v-model="naturezaOperacao"
                            label="Natureza da Operação"
                            required
                            readonly
                            disabled
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                     <v-flex xs12 sm4>
                        <v-text-field
                            v-model="regimeTributacao"
                            label="Regime Especial de Tributação"
                            required
                            readonly
                            disabled
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                     <v-flex xs12 sm4>
                        <v-text-field
                            v-model="issqn"
                            label="Município da incidência do ISSQN"
                            readonly
                            disabled
                            required
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-text-field>
                    </v-flex>

                     

                    <v-flex xs12 sm12>
                        <v-textarea
                            v-model="codigoTributacao"
                            label="Código de Tributação do Município (CTISS)"
                            readonly
                            disabled
                            required
                            row-height="10"
                            style="font-size: 0.8em;"
                            validate-on-blur
                            auto-grow
                            :rules="razaoRules"
                        ></v-textarea>
                    </v-flex>

                </v-layout>
                </v-container>
            </v-form>
            </v-card-text>
            <v-container grid-list-md text-xs-center style="padding-top: 2px;">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      block
                      outline
                      depressed
                      small
                      color="red"
                      @click="handleCancelar"
                    >Cancelar</v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      block
                      depressed
                      class="white--text"
                      small
                      color="teal"
                      @click="onSubmit"
                    >{{ !edit ? 'Incluir' : 'Atualizar' }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </article>
          </v-card>
        </v-dialog>

        <v-dialog @keydown.esc="dialogAviso = false" v-model="dialogAviso" max-width="700px">
          <v-card>
            <v-toolbar dark class="headline darkBlue">
              <v-toolbar-title>Aviso</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click.native="dialogAviso = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>

              <article>

              <v-card-text>
                <v-container> 
                  <h3>Foram encontradas duplicidades nos campos:</h3>
                  <br>
                  <h3> <b>CPF/CNPJ:</b> <span style="color:red">{{cnpjAviso}}</span></h3>
                  <br>
                  <h3><b>Data serviço:</b> <span style="color:red">{{dataAviso}}</span></h3>
                  <br>
                  <h3><b>Valor:</b> <span style="color:red">{{valorAviso ? `R$ ${valorAviso}` : ''  }}</span></h3>
                  <br>
                  <br>
                  <h4>Deseja prosseguir com a inclusão?</h4>
                  </v-container>
              </v-card-text>

              <v-container grid-list-md text-xs-center style="padding-top: 2px;">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      block
                      outline
                      depressed
                      small
                      color="red"
                      @click="dialogAviso=false"
                    >Cancelar</v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      block
                      depressed
                      class="white--text"
                      small
                      color="teal"
                      @click="handleDuplicidade"
                    >Incluir</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
              </article>
          </v-card>
        </v-dialog>
        </v-tooltip>
</template>

<script>
import NfseService from "@/domain/notas/nfse/NfseService";
import CommonService from "@/domain/dataTable/commonService/CommonService.js";

import Vue from "vue";
export default {
  props: [
    "empresa",
    "table",
    "component",
    "conta",
    "edit",
    "nota"
  ],
  data: () => ({
      inscricaoMunicipal: null,
      dialog: false,
      dialogAviso: false,
      failureMessages: '',
      cnpjAviso: '',
      dataAviso: '',
      valorAviso:'',
      cnpj: '',
      razao: '',
      estado: '',
      municipio: '',
      email: '',
      cep: '',
      bairro: '',
      logradouro: '',
      numero: '',
      complemento: '',
      codigoTributacao: 'Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.',
      naturezaOperacao: 'Tributação no município',
      regimeTributacao: 'Estimativa',
      issqn: 'Belo Horizonte',
      valor: '',
      telefone: '',
      date2: null,
      discriminacao: '',
      cepMax: '',
      showDate: false,
      arrayEstados: [],
      arrayMunicipios: [],
      valid: true,
      date: null,
      nowDate: new Date().toISOString().slice(0,10),
      today: new Date(),
      jsonDuplicidade: {},
      // dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      mask: { cnpj: "", cep: "", date: '##/##/####', telefone: '', },
      cpfRules: [
      v => !!v || "Campo obrigatório",
      cpf => {
        let sum, rest;
        if (
          cpf === undefined ||
          cpf === null ||
          cpf.trim().length === 0 ||
          cpf === "00000000000" ||
          cpf === "11111111111" ||
          cpf === "22222222222" ||
          cpf === "33333333333" ||
          cpf === "44444444444" ||
          cpf === "55555555555" ||
          cpf === "66666666666" ||
          cpf === "77777777777" ||
          cpf === "88888888888" ||
          cpf === "99999999999"
        ) {
          return "CPF inválido";
        }
        cpf = cpf
          .replace(".", "")
          .replace(".", "")
          .replace("-", "");

        sum = 0;
        for (let i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = (sum * 10) % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }
        rest = (sum * 10) % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }
        return true;
      }
    ],
    cnpjRules: [
      v => !!v || "Campo obrigatório",
      v => {
        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]);
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]);
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
      }
    ],
    razaoRules: [v => !!v || "Campo obrigatório"],
    dateRules: [v => !!v && v.length > 7 || "Data inválida",
      v => {
        if(v) {
          try {
            const currentYear = new Date().toISOString().substring(0, 10).split('-');
            let date = v.substring(0,2) + '-' + v.substring(2,4) + '-' + v.substring(4,8);
            date = date.split('-').reverse();
            const year = date[0];
            date = date.join('-');

            const dateAux = Date.parse(date);
            const today = Date.parse(new Date().toISOString().substring(0, 10));

            const validDate = new Date(date).toISOString().substring(0, 10);
            if(date != validDate) return 'Data inválida';
            if(!new Date(date).toISOString()) return 'Data inválida';
            if(today < dateAux ) return 'Data inválida';
            if(Number(currentYear[0] - 1) > Number(year)) return 'Data inválida';

            return true;
        
          }catch(err) {
            return 'Data inválida';
          }
        }else {
          return "Campo obrigatório";
        }
      }],
    emailRules: [v => (!!v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail inválido')],
    telefoneRules: [v => !!v && v.length > 9 || 'Telefone inválido']
  }),
  computed: {
    ufArray() {
      return this.$store.getters.ufArray;
    },
    getEstados: async function() {
      this.arrayEstados = this.ufArray;
      this.arrayMunicipios = [];
      // this.resource = this.$resource(
      //   "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
      // );
      // this.resource.query().then(
      //   success => {
      //     this.arrayMunicipios = [];
      //     this.arrayEstados = success.body;

      //     return success.body;
      //   },
      //   failed => {
      //     this.arrayEstados = [];
      //     return [];
      //   }
      // );
    },
    computedDateFormatted: {
      get() {
        return this.formatDate(this.date)
      },
    },
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getEstados;
    });
  },
  methods: {
    eventDate(event) {
      this.date = event;
      this.$refs.dataInput.focus();
    },
    validateDate() {
      if(this.date2 && this.date2.length === 8){
        let stringAux = '';
        stringAux = this.date2.substring(0,2) + '-' + this.date2.substring(2,4) + '-' + this.date2.substring(4,8);
        this.date = stringAux
          .split("-")
          .reverse()
          .join("-");
      }else {
        return;
      }
    },
    formatDate(date, menu) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}-${month}-${year}`;
    },
    handleOpenDialogInsert() {
      this.codigoTributacao = '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.';
      this.naturezaOperacao = 'Tributação no município';
      this.regimeTributacao = 'Estimativa';
      this.issqn = 'Belo Horizonte';
      this.dialog = true;
    },
    handleOpenDialog() {
      this.cnpj = this.nota.cnpjCpf;
      if(this.nota.cnpjCpf.length > 11) {
        this.mask.cnpj = "##.###.###/####-##";
      }else {
        this.mask.cnpj = "###.###.###-##";
      }

      this.failureMessages = this.nota.erroEmissao ? this.nota.erroEmissao : '';

      this.codigoTributacao = '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.';
      this.naturezaOperacao = 'Tributação no município';
      this.regimeTributacao = 'Estimativa';
      this.issqn = 'Belo Horizonte';
      this.valor = this.nota.vlrServico;
      this.razao = this.nota.razao;
      this.date2 = this.nota.dataServico.toLocaleDateString('pt-BR');
      this.date = this.date2.split('/').reverse().join('-');
      this.inscricaoMunicipal = this.nota.insc;
      for(let i in this.arrayEstados) {
        if(this.arrayEstados[i].sigla === this.nota.emissaoMotor.estado) {
          this.estado = this.arrayEstados[i];
          this.getMunicipios(this.nota.emissaoMotor.codMun);
          break;
        }
      }
      
      this.email = this.nota.emissaoMotor.email,
      this.cep =  this.nota.emissaoMotor.cep,
      this.mask.cep = "#####-###";
      this.bairro = this.nota.emissaoMotor.bairro,
      this.logradouro = this.nota.emissaoMotor.logradouro,
      this.numero = this.nota.emissaoMotor.numero,
      this.complemento = this.nota.emissaoMotor.complemento,
      this.discriminacao = this.nota.discriminacao;
      this.telefone = this.nota.emissaoMotor.telefone;
      
      this.dialog = true;
    },
    getMunicipios: async function(codMun = '') {
      if (this.estado) {
        this.resource = this.$resource(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.estado.id}/municipios`
        );
        this.resource.query().then(
          success => {
            if(codMun.length > 1){
              if(success.body.length) {
                for(let i in success.body) {
                  if(success.body[i].id == codMun) {
                    this.municipio = success.body[i];
                    break;
                  }
                }
              }
            }
            this.arrayMunicipios = success.body;
          },
          failed => {
            this.arrayMunicipios = [];
          }
        );
      }else {
        return;
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
     maskValor(valor, event) {
      if (valor != null) {
        let v = valor;
        v = this.addVirgula(v);
        v = v.replace(/(\d+)(\d{3},\d{2})$/g, "$1.$2");
        var qtdLoop = (v.length - 3) / 3;
        var count = 0;
        while (qtdLoop > count) {
          count++;
          v = v.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        }
        v = v.replace(/^(0+)(\d)/g, "$2");
        this.valor = v;
      }
    },
    addVirgula: function(v) {
      v = v.replace(/\D/g, ""); //Remode tudo o que não é dígito
      v = v.replace(/(\d+)(\d{2})/, "$1,$2");
      return v;
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    
    trocaCampoCpfCnpj: function(e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.cnpj = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpj = "##.###.###/####-##";
        } else if (v && v.length >= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpj = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpj = "###.###.###-##";
        }
      }
    },
    trocaCampoDate: function(e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.date = "";
      } else {
        this.mask.date = "##/##/####";
      }
    },
    trocaCampoCep: function(e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.cep = "";
      } else {
        this.mask.cep = "#####-###";
      }
    },
    verificaCNPJ($event) {
      this.setRazao();
      this.consultaCNPJbd();
      this.returnEmpresa($event);
    },
    setRazao() {
      this.service.getAPIReceita(this.cnpj).then(success => {
        if (success && success.body) {
          if (success.body.hasOwnProperty("nome")) {
            this.razao = success.body.nome;
          }
          if (success.body.hasOwnProperty("uf") && success.body.uf.length > 0) {
            this.arrayEstados.forEach(estado => {
              if (
                success.body.uf.toLocaleLowerCase() ==
                estado.sigla.toLocaleLowerCase()
              ) {
                this.estado = estado;
                this.empresa["uf"] = estado.id;
              }
            });
          }
          this.$refs.cnpj.validate();
        }
      });
    },
    consultaCNPJbd() {
      this.service.getEmpresasCnpj(this.cnpj).then(
        success => {
          // trocar para algo melhor
          if (this.cnpjRules[this.cnpjRules.length - 1].name.length != 0) {
            this.cnpjRules.pop();
          }
          if (this.cpfRules[this.cpfRules.length - 1].name.length != 0) {
            this.cpfRules.pop();
          }
          if (success && success.status != 404) {
            this.cnpjRules.push(function indisponivel(value) {
              if (
                success.body.items.length > 0 &&
                value == success.body.items[0].cnpj
              ) {
                return "CNPJ já utilizado no sistema";
              }
              return true;
            });
            this.cpfRules.push(function indisponivel(value) {
              if (
                success.body.items.length > 0 &&
                value == success.body.items[0].cnpj
              ) {
                return "CPF já utilizado no sistema";
              }
              return true;
            });
          }
          this.$refs.cnpj.validate();
          return this.$refs.cnpj.valid;
        },
        failed => {
          return failed;
        }
      );
    },
    handleCancelar() {
      this.dialog = false;
      this.arrayMunicipios = [];
      this.resetForm();
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {

        this.cnpjAviso = '',
        this.dataAviso = '',
        this.valorAviso = '',

        this.cnpjAviso = this.cnpj;
        this.dataAviso = this.date.split('-').reverse().join('/');
        this.valorAviso = this.valor;

        this.telefone.replace('(', '');
        this.telefone.replace(')', '');


        if(this.valor.length > 2) {
          this.valor = this.valor.split('.').join('');
          this.valor = this.valor.replace(',', '.');
        }
        
        if(this.cnpj.length > 14) {
          this.cnpj = this.cnpj.split('/').join('');
        }
        this.cnpj = this.cnpj.split('.').join('');
        this.cnpj = this.cnpj.split('-').join('');
        

        let convertData = this.date.split('-');
        if(Number(convertData[2]) < 10) {
          convertData[2] = convertData[2].replace('0', '');
        }

        this.date = convertData.join('-');

        const nfseObj = {
          dataServico: this.date,
          cpfCnpj: this.cnpj,
          razao: this.razao,
          email: this.email,
          cep: this.cep,
          estado: this.estado.sigla,
          codMun: this.municipio.id,
          bairro: this.bairro,
          logradouro: this.logradouro,
          numero: this.numero,
          complemento: this.complemento,
          inscTomador: this.inscricaoMunicipal,
          codigoTributacao: this.codigoTributacao,
          naturezaOperacao: this.naturezaOperacao,
          regimeTributacao: this.regimeTributacao,
          issqn: this.issqn,
          telefone: this.telefone,
          valorTotal: this.valor,
          discriminacao: this.discriminacao,
        }
        


        this.snackbar = true
        this.dialog = false;
        this.resetForm();


        this.service = new NfseService(this.$http);
        if(!this.edit){
          this.table.loading = true;
          await this.service.inserirNovaNota(nfseObj, this.empresa._id).then( async (resp) => {
            this.$store.commit('addUpdateTable', true);
            if(resp.message === 'Duplicidade') {
              this.jsonDuplicidade = nfseObj;
              this.dialogAviso = true;
            }
          }).then(() => {
            this.$store.commit('addUpdateTable', false);
          });
        } else {
          this.table.loading = true;
          await this.service.atualizarNota(nfseObj, this.nota._id).then( async (resp) => {
            this.$store.commit('addUpdateTable', true);
            if(resp.message === 'Duplicidade') {
              this.jsonDuplicidade = nfseObj;
              this.dialogAviso = true;
            }
          }).then(() => {
            this.$store.commit('addUpdateTable', false);
          });
        }
      }
    },
    async handleDuplicidade() {
      this.service = new NfseService(this.$http);
      const json = { ...this.jsonDuplicidade, aceiteDuplicidade: this.conta.id_usuario };
      this.table.loading = true;
      await this.service.inserirNovaNota(json).then(() => {
        this.dialogAviso = false;
        this.$store.commit('addUpdateTable', true);
      }).then(() => {
        this.$store.commit('addUpdateTable', false);
      })
    },
    resetForm() {
      this.$refs.form.reset()
    },
  }
};
</script>
<style scoped>

#btn_consultaAvulsa {
  background: linear-gradient(white, #d3d3d3);
}

.v-form>.container>.layout>.flex {
    padding: 3px 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnNovaNota/BtnNovaNota.vue